window.bootstrap = require("bootstrap");
var hash_array = ['#metadata', '#readme', '#version', '#review-history', '#json-ld', '#datacite-json', '#jpcoar-schema-xml', '#nims-rdm-yaml']

window.addEventListener('DOMContentLoaded',function(){
  var hash = window.location.hash;
  if(hash_array.includes(hash)) {
    var tab_link = document.querySelector('ul.nav.nav-tabs a[href="' + hash + '"]');
    var tab = new bootstrap.Tab(tab_link);
    tab.show();
  }
});
